export default __webpack_public_path__ + "9fb5983513249eb6cc53f8d3bb98d82e.png";